module.exports = __webpack_public_path__ + "images/spun-out-b8571a97ff83d92f9220674ac80b53f6.png";